import { render, staticRenderFns } from "./Welcome2.vue?vue&type=template&id=628e0bd1&scoped=true&"
import script from "./Welcome2.vue?vue&type=script&lang=js&"
export * from "./Welcome2.vue?vue&type=script&lang=js&"
import style0 from "./Welcome2.vue?vue&type=style&index=0&id=628e0bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e0bd1",
  null
  
)

export default component.exports